'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _withData = require('../withData');

var _withData2 = _interopRequireDefault(_withData);

var _actions = require('./actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HomeUrlWatcher = function (_React$Component) {
  (0, _inherits3.default)(HomeUrlWatcher, _React$Component);

  function HomeUrlWatcher() {
    (0, _classCallCheck3.default)(this, HomeUrlWatcher);
    return (0, _possibleConstructorReturn3.default)(this, (HomeUrlWatcher.__proto__ || (0, _getPrototypeOf2.default)(HomeUrlWatcher)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeUrlWatcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleHomeUrl();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleHomeUrl();
    }
  }, {
    key: 'handleHomeUrl',
    value: function handleHomeUrl() {
      var home = this.props.home;
      var store = this.context.store;


      if ((0, _lodash.has)(home, 'address.streetAddress')) {
        store.dispatch((0, _actions.addRecentHome)((0, _lodash.get)(home, '_id')));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return HomeUrlWatcher;
}(_react2.default.Component);

HomeUrlWatcher.propTypes = {
  home: _propTypes2.default.object.isRequired
};

HomeUrlWatcher.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _withData2.default)({ home: true })(HomeUrlWatcher);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Homes/HomeUrlWatcher.js
// module id = 943
// module chunks = 0